export const ruleTypes = [{ value: '', label: 'General' }];

export const ruleOperators = [
  '(',
  ')',
  '+',
  '-',
  '*',
  '/',
  'AND',
  '==',
  '!=',
  '>',
  '<',
  '>=',
  '<=',
  'OR',
];

export const RuleComposerType = {
  Text: 'Text',
  Date: 'Date',
  Doc_Field: 'Search Doc Field',
  LOS_Field: 'Search LOS Field',
  Document_Type: 'Search Document Type',
  TableColumn_Field: 'Search Table Column',
};

export const RuleTextboxType = {
  Text: 'Enter Value:',
  Date: 'Select Date:',
  Doc_Field: 'Document Field:',
  LOS_Field: 'LOS Field:',
  Document_Type: 'Document Type:',
  TableColumn_Field: 'Document Table:',
};
